import {apiRequest} from "./API"

export default {
    // Submit MoveIn
    SubmitMoveIn: async (moveIn) => {
        console.log("NM", moveIn)
        let MoveInSubmission = await apiRequest(`/customermovein`, "POST", moveIn);
        return MoveInSubmission;
    }
}